
export const getLocations = async (resource) => {
    let locations;
    await resource
      .get(`api/${localStorage.getItem('perfil')}/location`)
      .then(
        (response) => {
          console.log(response);
          locations = response.body.data;
        },
        (response) => {
          console.log(response);
        }
      );
    return locations;
  }
  export const getFindByStablishment = async (resource,id) => {
    let locations;
    await resource
      .get(`api/${localStorage.getItem('perfil')}/location/find_by_stablishment_id/${id}`)
      .then(
        (response) => {
          console.log(response);
          locations = response.body.location;
        },
        (response) => {
          console.log(response);
        }
      );
    return locations;
  }